// extracted by mini-css-extract-plugin
module.exports = {"animationTicker":"Hero_animationTicker__NY_Hp","ticker":"Hero_ticker__wIXzz"};